<div id="footer" class="container-large">
  <div id="footer-desktop" class="footer-wrap">
    <div class="footer-section">
      <div class="footer-logo">
        <img *ngIf="!isOutside" width="155" height="22" [src]="'assets/images/zavedenia-logo.svg'" alt="{{this.word[this.language].venues}}">
        <img class="booky" *ngIf="currentCity === 'skopje'" width="155" height="22" [src]="'assets/images/bookylogo.svg'" alt="{{this.word[this.language].venues}}">
        <img class="booky" *ngIf="currentCity === 'beograd'" width="155" height="22" [src]="'assets/images/booknowlogo.svg'" alt="{{this.word[this.language].venues}}">
        <span> &copy; 2025</span>
      </div>
      <div class="footer-p">
        <span class="footer-p-span">{{this.word[this.language].footerInfo1}}</span>
        <p class="footer-p-des">{{this.word[this.language].footerInfo2}}</p>
      </div>
    </div>
    <div class="links-group d-flex-row">
      <div class="footer-section footer-links">
        <h3 class="footer-title">
          {{this.word[this.language].footerForClients}}
        </h3>
        <ul class="footer-link-list">
          <li class="link"><a [routerLink]="['/','page','terms']" href="javascript:;" title="{{this.word[this.language].termsOfUse}}, {{this.word[this.language].zavedeniaBG}}">{{this.word[this.language].termsOfUse}}</a></li>
          <li class="link"><a [routerLink]="['/','page','privacy']" href="javascript:;"  title="{{this.word[this.language].personalData}}, {{this.word[this.language].zavedeniaBG}}">{{this.word[this.language].personalData}}</a></li>
          <li class="link"><a [routerLink]="['/','page','feedback']" href="javascript:;"  title="{{this.word[this.language].feedback}}, {{this.word[this.language].zavedeniaBG}}">{{this.word[this.language].feedback}}</a></li>
        </ul>
      </div>
      <div class="footer-section footer-links">
        <h3 class="footer-title">
          {{this.word[this.language].footerForPartners}}
        </h3>
        <ul class="footer-link-list">
          <li class="link"><a href="http://sofia1.zavedenia.com/login/page/services/"  title="{{this.word[this.language].addVenue}}, {{this.word[this.language].zavedeniaBG}}">{{this.word[this.language].addVenue}}</a></li>
          <li class="link"><a [routerLink]="['/','page','partner']" href="javascript:;"  title="{{this.word[this.language].forInvestors}}, {{this.word[this.language].zavedeniaBG}}">{{this.word[this.language].forInvestors}}</a></li>
          <li class="link"><a [routerLink]="['/','page','howto']" title="{{this.word[this.language].ad}}, {{this.word[this.language].zavedeniaBG}}">{{this.word[this.language].ad}}</a></li>
        </ul>
      </div>

      <div class="footer-section footer-links">
        <h3 class="footer-title">
          {{this.word[this.language].footerAbout}}
        </h3>
        <ul class="footer-link-list">
          <li class="link"><a [routerLink]="['/','page','aboutus']" href="javascript:;"  title="{{this.word[this.language].development}}, {{this.word[this.language].zavedeniaBG}}">{{this.word[this.language].development}}</a></li>
          <li class="link"><a [routerLink]="['/','page','contacts']" href="javascript:;"  title="{{this.word[this.language].contacts}}, {{this.word[this.language].zavedeniaBG}}">{{this.word[this.language].contacts}}</a></li>
          <li class="link"><a [routerLink]="['/','page','help']" href="javascript:;"  title="{{this.word[this.language].help}}, {{this.word[this.language].zavedeniaBG}}">{{this.word[this.language].help}}</a></li>
        </ul>
      </div>
      <div class="footer-section footer-links">
        <h3 class="footer-title">
          English
        </h3>
        <ul class="footer-link-list">
          <li class="link"><a [routerLink]="['en/','page','investors']" href="javascript:;"  title="For Investors, zavedenia.bg">For Investors</a></li>
        </ul>
      </div>
      <div *ngIf="!this.isOutside"  class="footer-section footer-links our-links-wrap">
        <div class="our-links">
          <h3 class="footer-title">
            {{this.word[this.language].footerFollowUs}}
          </h3>
          <ul class="footer-link-list media-links social-media d-flex-row">
            <li class="social-media">
              <a href="https://facebook.com/zavedenia" rel="noreferrer" target="_blank" class="social-media-link" title="Facebook, {{this.word[this.language].zavedeniaBG}}">
                <i class="fa fa-facebook" aria-hidden="true"></i>
              </a>
            </li>
            <li class="social-media">
              <a href="https://twitter.com/zavedenia" rel="noreferrer" target="_blank" class="social-media-link" title="Twitter, {{this.word[this.language].zavedeniaBG}}">
                <i class="fa fa-twitter" aria-hidden="true"></i>
              </a>
            </li>
            <li class="social-media">
              <a href="https://instagram.com/zavedenia_bg" rel="noreferrer" target="_blank" class="social-media-link" title="Instagram, {{this.word[this.language].zavedeniaBG}}">
                <i class="fa fa-instagram" aria-hidden="true"></i>
              </a>
            </li>
            <li class="social-media">
              <a href="https://www.youtube.com/user/zavedenia" rel="noreferrer" target="_blank"
                class="social-media-link" title="Youtube, {{this.word[this.language].zavedeniaBG}}">
                <i class="fa fa-youtube-play" aria-hidden="true"></i>
              </a>
            </li>
          </ul>
        </div>
        <div class="our-links">
          <h3 class="footer-title">
            <!--  {{this.word[this.language].footerSites}} -->
          </h3>
          <ul *ngIf="!isOutside" class="footer-link-list social-media">
            <li class="link"><a href="https://order.bg" title="{{this.word[this.language].foodForHome}}" class="d-flex-center"> <img width="24px" height="18" class="img-tag"
                  src="assets/images/order-tiny.png" alt="{{this.word[this.language].foodForHome}}">order.bg</a></li>
            <li class="link"><a href="https://booky.bg/" title="{{this.word[this.language].bookTable}}" class="d-flex-center"> <img width="19px" height="18" class="img-tag"
                  src="assets/images/booky-tiny.png" alt="{{this.word[this.language].bookTable}}">booky.bg</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
